import { Web3ChainId } from '../web3.types';
import { Web3ChainProtocol } from './web3.protocols';

export const Webe3Chains: Record<Web3ChainProtocol, Web3ChainId> = {
  ERC20: 1,
  BEP20: 56,
  ETH_SEPOLIA: 11_155_111,
  ETH_GOERLI: 5,
  BNB_TEST: 97,
  POLYGON: 137,
};
